export default function Footer() {
  return (
    <footer className="mt-5 TWeather">
      This project was coded by{" "}
      <a
        href="https://github.com/Liubov-Ukr"
        target="_blank"
        rel="noopener noreferrer"
      >
        Liubov Opryshchenko
      </a>{" "}
      and is{" "}
      <a
        href="https://github.com/Liubov-Ukr/weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        open-sourced on GitHub
      </a>
    </footer>
  );
}
